export interface IStationsList {
  from: string[];
  to: string[];
}

// :NV-5923 Listan måste hållas i synk med listan för validering i backend: Backend/Web/Features/Pages/DelayCompensationOresundstag/DelayCompensationOresundstagValidationHelpers.cs
export const oresundstagStations: IStationsList = {
  from: ['Göteborg C', 'Kungsbacka', 'Mölndal', 'Åsa'],
  to: [
    'Alvesta',
    'Bergåsa',
    'Bromölla',
    'Bräkne-Hoby',
    'Burlöv',
    'Båstad',
    'CPH Airport Kastrup',
    'Emmaboda',
    'Eslöv',
    'Falkenberg',
    'Göteborg C',
    'Halmstad',
    'Helsingborg',
    'Hovmantorp',
    'Hyllie',
    'Hässleholm',
    'Höör',
    'Kalmar',
    'Karlshamn',
    'Karlskrona',
    'Kristianstad',
    'Kungsbacka',
    'Kävlinge',
    'Köpenhamn H',
    'Laholm',
    'Landskrona',
    'Lessebo',
    'Lund',
    'Malmö C',
    'Mölndal',
    'Mörrum',
    'Nybro',
    'Nørreport',
    'Osby',
    'Ramlösa',
    'Ronneby',
    'Sölvesborg',
    'Triangeln',
    'Tåmby',
    'Varberg',
    'Växjö',
    'Älmhult',
    'Ängelholm',
    'Åsa',
    'Ørestad',
    'Østerport',
  ],
};
